import {
    createFeatureSelector,
    createSelector
} from '@ngrx/store';
import {
    DATIQ_LOG_FEATURE_KEY,
    datiqLogAdapter,
    DatiqLogPartialState,
    IDatiqLogEntity,
    State,
} from './datiq-log.models';

import * as Utils from './datiq-log-selectors-utils';
import { IDatiqLog } from '../models';
import { Dictionary } from '@ngrx/entity';

// Lookup the 'DatiqLog' feature state managed by NgRx
export const getDatiqLogState = createFeatureSelector<
    DatiqLogPartialState,
    State
>(DATIQ_LOG_FEATURE_KEY);

const { selectAll, selectEntities } = datiqLogAdapter.getSelectors();

export const getDatiqLogLoaded = createSelector(
    getDatiqLogState,
    (state: State) => state.loaded
);

export const getDatiqLogError = createSelector(
    getDatiqLogState,
    (state: State) => state.error
);

export const getAllDatiqLog = createSelector(getDatiqLogState, (state: State) =>
    selectAll(state)
);

export const getDatiqLogEntities = createSelector(
    getDatiqLogState,
    (state: State) => selectEntities(state)
);

export const getSelectedId = createSelector(
    getDatiqLogState,
    (state: State) => state.selectedId
);

export const getSelected = createSelector(
    getDatiqLogEntities,
    getSelectedId,
    (entities, selectedId) => selectedId && entities[selectedId]
);

export const getLogs = () =>
    createSelector(
        getDatiqLogEntities,
        (entities: Dictionary<IDatiqLogEntity>): IDatiqLog[] =>
            Utils.getLogs(entities)
    );
